const EnquiryAPIURL = {

    //#region AboutWhyus
    GetEnquiryNow: 'api/Enquiry/GetEnquiryNow',
    UpdateEnquiryNow: 'api/Enquiry/UpdateEnquiryNow',
    AddEnquiry: 'api/Enquiry/AddEnquiry',
    GetEnquiryDetails: 'api/Enquiry/GetEnquiryDetails',
    UpdatePersonalInfo: 'api/Enquiry/UpdatePersonalInfo',
    UpdateGuestDetails: 'api/Enquiry/UpdateGuestDetails',
    UpdatePackageDetails: 'api/Enquiry/UpdatePackageDetails',
    UpdatePaymentDetails: 'api/Enquiry/UpdatePaymentDetails',
    //#endregion

}
export default EnquiryAPIURL;